import { render, staticRenderFns } from "./ClinicTreatment.vue?vue&type=template&id=2375011a"
import script from "./ClinicTreatment.vue?vue&type=script&lang=js"
export * from "./ClinicTreatment.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports